var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[_c('b-table',{attrs:{"data":_vm.presentData,"columns":_vm.columns,"sticky-header":"","height":"calc(100vh - 52px)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }